import {
  FormHelperText,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useForm, useFormState } from "react-final-form";

import CannotViewField from "../fields/CannotViewField";
import { get } from "lodash";
import { useDebounce } from "ra-friendsofbabba";
import useEvalJudgments from "./useEvalJudgments";
import usePrivileges from "../usePrivileges";
import { useRef } from "react";
import { useTranslate } from "ra-core";

const JudgmentItemRow = ({ disabled, item, choices, useNotes, source }) => {
  const translate = useTranslate();
  const form = useForm();
  const formState = useFormState();
  const { value, notes, validationError } = useMemo(() => {
    const filledItems = get(formState.values, source, []);
    const target = filledItems.find((fi) => fi.eval_item_id === item.id);
    const index = filledItems.indexOf(target);
    let id = get(target, "eval_judgment_id", 0);

    if (id === null) {
      id = 0;
    }
    let notes = get(target, "notes", "");
    if (notes === null) {
      notes = "";
    }
    const submitError = get(formState.submitErrors, source);
    const validationError = get(submitError, `${index}.value`);
    return { value: id, notes, validationError };
  }, [formState, item, source]);
  const [id, setId] = useState(value);
  const [text, setText] = useState(notes);
  const debouncedId = useDebounce(id, 500);
  const debouncedText = useDebounce(text, 500);
  const handleChange = useCallback((e) => setId(e.target.value), []);
  const handleTextChange = useCallback((e) => setText(e.target.value), []);
  const didMount = useRef(false);
  useEffect(
    () => {
      if (didMount.current === false) {
        didMount.current = true;
        return;
      }
      const filledItems = get(formState.values, source, []);
      const target = filledItems.find((fi) => fi.eval_item_id === item.id);
      target.eval_judgment_id = debouncedId > 0 ? debouncedId : null;
      target.notes = debouncedText;
      form.change(source, [...filledItems]);
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedId, debouncedText]
  );

  return (
    <TableRow key={item.id}>
      <TableCell>
        <Typography color={validationError && "error"} variant="body2">
          {item.name}
        </Typography>
        {useNotes && (
          <TextField
            label={translate(
              "resources.technical-report-eval-items.fields.notes"
            )}
            variant="filled"
            onChange={handleTextChange}
            value={text}
            multiline
            maxRows={4}
            minRows={2}
            disabled={disabled}
            fullWidth
          />
        )}
      </TableCell>
      <TableCell>
        <Select
          fullWidth
          variant="filled"
          value={id}
          disabled={disabled}
          error={validationError && validationError !== null}
          onChange={handleChange}
        >
          <MenuItem value={0}></MenuItem>
          {choices.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              {option.name}
            </MenuItem>
          ))}
        </Select>
        {validationError && (
          <FormHelperText error>{validationError}</FormHelperText>
        )}
      </TableCell>
    </TableRow>
  );
};
const JudgmentItemInputWrapper = ({
  evalItems,
  group,
  useNotes = false,
  ...props
}) => {
  const items = useMemo(
    () => evalItems.filter((ei) => ei.group === props.bind),
    [evalItems, props.bind]
  );
  let evalJudgments = useEvalJudgments().filter(
    (ej) => !group || ej.group === group
  );

  if (items.length === 0 || evalJudgments.length === 0) {
    return null;
  }
  return (
    <Table>
      <TableBody>
        {items
          .filter((i) =>
            props?.record?.technical_report?.technical_report_group_id < 3
              ? i.id < (group === "2" ? 21 : 31)
              : i.id !== undefined
          )
          .map((item) => (
            <JudgmentItemRow
              key={item.id}
              item={item}
              choices={evalJudgments}
              useNotes={useNotes}
              {...props}
            />
          ))}
      </TableBody>
    </Table>
  );
};
const JudgmentItemInput = ({ tab, ...props }) => {
  // const visible = useTabVisibiliy(tab);
  // if (!visible && tab > 0) {
  //   return null;
  // }
  const { canView } = usePrivileges({ ...props });
  if (!canView) {
    return <CannotViewField {...props} />;
  }
  return <JudgmentItemInputWrapper {...props} />;
};
export default JudgmentItemInput;
